import React from 'react'
import Select from 'react-select'
import Header from './Header'
import Input from './form/Input'
import { buttons } from '../helpers/const'

class Billing extends React.Component {
  constructor(props) {
    super(props);

    this.state = { };
  }

  render() {
    const { currentUser } = this.props;

    const CountryOptions = [
      { value: 'option1', label: 'Country' },
      { value: 'option2', label: 'option2' },
      { value: 'option3', label: 'option3' }
    ]

    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.persona.text}
            buttonUrl={buttons.persona.url}
            currentUser={currentUser}
          />

          <div className="col-12 py-110 sm-py4">
            <div className="md-px3 mx-auto" style={{ maxWidth: '1010px' }}>
              <p className="title center mb-30 ">Billing</p>

              <form className="mx-auto" style={{ maxWidth: '370px' }}>
                <div className="mb-20">
                  <Input label="Billing name" />
                </div>

                <div className="mb-20">
                  <Input label="Street address" />
                </div>

                <div className="flex mb-20 mxn-10">
                  <div className="col-6 px-10">
                    <Input label="ZIP / Postal code" />
                  </div>

                  <div className="col-6 px-10">
                    <Input label="City" />
                  </div>
                </div>

                <div className="mb-30">
                  <Select
                    classNamePrefix="react-select"
                    defaultValue={CountryOptions[0]}
                    options={CountryOptions}
                  />
                </div>

                <div className="mb-30">
                  <input
                    className="btn btn--primary col-12"
                    type="submit"
                    value="Save"
                  />
                </div>

                <p className="center h2 mb-30 text-tuna">Invoices</p>

                <div className="bg-white box-shadow-box border border-gallery mb-10 p-20 rounded-6">
                  <p className="fs-11 mb1 sfpro-regular">14 January, 2019</p>

                  <div className="flex flex-justify fs-18 mb2 text-tuna">
                    <p className="pr2">Lorem ipsum dolor</p>

                    <p>$99</p>
                  </div>

                  <a
                    className="btn btn--primary btn--primary--wisp-pink btn--fs-12 btn--lh-28 col-12"
                    href="#"
                    style={{ maxWidth: '120px' }}
                  >
                    Download
                  </a>
                </div>

                <div className="bg-white box-shadow-box border border-gallery mb-10 p-20 rounded-6">
                  <p className="fs-11 mb1 sfpro-regular">14 January, 2019</p>

                  <div className="flex flex-justify fs-18 mb2 text-tuna">
                    <p className="pr2">Lorem ipsum dolor</p>

                    <p>$99</p>
                  </div>

                  <a
                    className="btn btn--primary btn--primary--wisp-pink btn--fs-12 btn--lh-28 col-12"
                    href="#"
                    style={{ maxWidth: '120px' }}
                  >
                    Download
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Billing
